import type { TimeOffDashboardSummary } from '../../../api/timeOff';
import { DashboardCardLinkButton } from './DashboardCardLinkButton';
import { displayEmployeeName, formatDashboardDateRange } from './dashboardCardFormatters';

interface TimeOffTodayCardProps {
  summary: TimeOffDashboardSummary;
  openAllHref: string;
}

export function TimeOffTodayCard({ summary, openAllHref }: TimeOffTodayCardProps) {
  return (
    <section className="dashboard-card dashboard-card--time-off">
      <div className="dashboard-card__header">
        <div>
          <h3 className="dashboard-card__title">Time Off</h3>
          <p>Today and the next seven days</p>
        </div>
        <DashboardCardLinkButton text="Open All" href={openAllHref} />
      </div>

      <div className="dashboard-kpi-row">
        <div className="dashboard-kpi">
          <span className="dashboard-kpi__value">{summary.todayOutCount}</span>
          <span className="dashboard-kpi__label">Out today</span>
        </div>
        <div className="dashboard-kpi">
          <span className="dashboard-kpi__value">{summary.nextSevenDaysCount}</span>
          <span className="dashboard-kpi__label">Next 7 days</span>
        </div>
      </div>

      <div className="dashboard-card__section">
        <h4 className="dashboard-card__section-title">Next 7 Days Upcoming</h4>
        {summary.upcoming.length === 0 ? (
          <p className="dashboard-empty">No upcoming time off in the next seven days.</p>
        ) : (
          <ul className="dashboard-upcoming-list">
            {summary.upcoming.slice(0, 5).map((item) => (
              <li key={item.id}>
                <span>
                  <strong>{displayEmployeeName(item)}</strong>
                  <small>{item.type} · {item.status}</small>
                </span>
                <span>{formatDashboardDateRange(item)}</span>
              </li>
            ))}
          </ul>
        )}
      </div>

      {summary.byType.length > 0 ? (
        <div className="dashboard-type-row" aria-label="Time off by type">
          {summary.byType.map((x) => (
            <span key={x.type} className="dashboard-pill">
              {x.type}: {x.count}
            </span>
          ))}
        </div>
      ) : null}
    </section>
  );
}
